import dayjs from "dayjs";

export const formatDate = (date: dayjs.Dayjs | undefined) => date && date.format("YYYY-MM-DD");

interface FormatDateOptions {
  yearFormat?: "YY" | "YYYY"; // Optional parameter for year format
  dateFormat?: string; // Optional parameter for custom date format
}

export const formatDateLocale = (
  date: dayjs.Dayjs | undefined,
  options: FormatDateOptions = {}
) => {
  if (!date) return "";

  const defaultFormat = dayjs().localeData().longDateFormat("L");
  const format = options.dateFormat || defaultFormat;

  const yearFormat = options.yearFormat || "YYYY";
  const shortYearFormat = format.replace(/YYYY/g, yearFormat);

  return date.format(shortYearFormat);
};

export const getDate = (date: Date): string | null => {
  if (isDateNull(date)) return null;
  return formatDateLocale(dayjs(date));
};

/**
 * Check if the Date object was initialised with null or undefined. Such values return Jan 1 1970 (beginning of Unix epoch)
 * Using getTime() returns 0 since it is 0 seconds since the Unix epoch.
 * @param date - The date to check
 * @returns True if the date is null or undefined, false otherwise
 */
const isDateNull = (date: Date): boolean => date.getTime() === 0;
